export default {
  modals: {
    delete_payment_method: {
      title: '¿Seguro que quieres eliminar este método de pago?',
    },
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_delete_payment_method: 'No se pudo eliminar el método de pago',
    payment_method_deleted: 'Método de pago eliminado',
  },
};
